const camelCase = require('lodash/camelCase');

function keysToCamelCase(obj) {
  if (typeof obj !== 'object') {
    return obj;
  }
  return Object.keys(obj).reduce(
    (memo, key) => ({
      ...memo,
      [camelCase(key)]: keysToCamelCase(obj[key]),
    }),
    {}
  );
}

module.exports = keysToCamelCase;
